import { useContext } from 'react'
import { EmailVerificationContext } from '../contexts/emailVerificationContextValue'

export const useEmailVerification = () => {
  const context = useContext(EmailVerificationContext)
  if (context === undefined) {
    throw new Error('useEmailVerification must be used within an EmailVerificationProvider')
  }
  return context
}
